// extracted by css-extract-rspack-plugin
export default {"container":"container-tUhW6t","moxie-fade-up":"moxie-fade-up-CS0D_K","moxieFadeUp":"moxie-fade-up-CS0D_K"};